var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumbersLinkedList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.05208 6.13333H19.7188M9.05208 12.5333H19.7188M9.05208 18.9333H19.7188M3.75431 16.5241C3.8058 16.3318 3.91007 16.1578 4.05533 16.0216C4.20059 15.8855 4.38104 15.7928 4.57627 15.7539C4.7715 15.715 4.97371 15.7315 5.16004 15.8016C5.34637 15.8716 5.50938 15.9924 5.63063 16.1503C5.75189 16.3082 5.82654 16.4968 5.84615 16.6949C5.86576 16.893 5.82954 17.0926 5.7416 17.2712C5.65366 17.4498 5.51749 17.6002 5.34851 17.7055C5.17954 17.8107 4.98448 17.8665 4.78542 17.8667C4.98416 17.8666 5.17897 17.922 5.34789 18.0267C5.51681 18.1314 5.65312 18.2813 5.74144 18.4593C5.82977 18.6373 5.8666 18.8365 5.84778 19.0343C5.82896 19.2322 5.75523 19.4208 5.63493 19.579C5.51462 19.7372 5.35251 19.8587 5.16688 19.9296C4.98124 20.0006 4.77947 20.0183 4.58431 19.9808C4.38915 19.9432 4.20837 19.8519 4.06234 19.7171C3.91632 19.5823 3.81086 19.4093 3.75786 19.2178M3.71875 11.4667C3.71875 11.1838 3.83113 10.9125 4.03117 10.7124C4.23121 10.5124 4.50252 10.4 4.78542 10.4C5.06831 10.4 5.33963 10.5124 5.53966 10.7124C5.7397 10.9125 5.85208 11.1838 5.85208 11.4667C5.85219 11.8119 5.73483 12.147 5.51928 12.4167L3.71875 13.6H5.85208M3.71875 4H4.25208C4.39353 4 4.52919 4.05619 4.62921 4.15621C4.72923 4.25623 4.78542 4.39188 4.78542 4.53333V8.26667M3.71875 8.26667H5.85208",
    stroke: "#424242",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumbersLinkedList);
export default __webpack_public_path__ + "static/media/numbers-linked-list.bbb613e0e8bf9761f9e70eaba4058f9f.svg";
export { ForwardRef as ReactComponent };